module.exports = __webpack_public_path__ + "static/img/float-bg.979dc65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/float-bg.png
// module id = ZWgl
// module chunks = 1